import { useContext, useEffect, useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";
import AuthClient from "../api/AuthClient";
import MyPartyDetail from "../components/MyPartyDetail/myPartyDetail";
import MyPartyDetailSkeleton from "../components/MyPartyDetail/MyPartyDetailSkeleton";
import NoPartyBanner from "../components/NoPartyBanner";
import { PartiesContext } from "../GlobalContext/partiesContext";
import SortPartyGroupsByDate from "../SortPartyGroupsByDate";
import { useMyParty } from "../hooks/useServerDataQueries";

const MyPartyDetails = () => {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const {
    selectedParty,
    setMyPartiesInfoContextData,
    setSelectedPartyContextData,
  } = useContext(PartiesContext);
  const { data: queriedParty, isError, isLoading, isFetching } = useMyParty(id);

  const authClient = useMemo(() => new AuthClient(), []);
  const isLoggedIn = authClient.isLoggedIn();

  useEffect(() => {
    if (!isLoggedIn) {
      navigate("/login");
    }
  }, [isLoggedIn, navigate]);

  useEffect(() => {
    if (!id) {
      setSelectedPartyContextData(null);
      return;
    }

    if (!queriedParty) {
      if (isError) {
        setSelectedPartyContextData(null);
      }
      return;
    }

    setSelectedPartyContextData(queriedParty);
    setMyPartiesInfoContextData((previousParties) => {
      const nextParties = previousParties.some((party) => party.party.id === queriedParty.party.id)
        ? previousParties.map((party) =>
          party.party.id === queriedParty.party.id ? queriedParty : party
        )
        : [...previousParties, queriedParty];

      return SortPartyGroupsByDate(nextParties);
    });
  }, [id, isError, queriedParty, setMyPartiesInfoContextData, setSelectedPartyContextData]);

  if (isLoading || (isFetching && !queriedParty && !selectedParty)) {
    return <MyPartyDetailSkeleton />;
  }

  if (selectedParty?.party.id === id) {
    return <MyPartyDetail />;
  }

  return <NoPartyBanner />;
};

export default MyPartyDetails;
